import script from "./selectproductComp.vue?vue&type=script&setup=true&lang=js"
export * from "./selectproductComp.vue?vue&type=script&setup=true&lang=js"

import "./selectproductComp.vue?vue&type=style&index=0&id=d4445fec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4445fec"]])

export default __exports__